import { mapMutations } from 'vuex'

export const pageOn = {
    watch: {
        pageOn ( pageOn ) {
            !pageOn && this.popPage(this.$options.name);
        }
    },
    mounted () {
        setTimeout(() => this.pageOn = true,10)
    },
    data () {
        return {
            pageOn: false,
        }
    },
    methods: {
        ...mapMutations(['popPage'])
    }
}